import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainerBase from 'remote-com-shared/components/ContentContainer';
import { SectionWrapper } from 'remote-com-shared/components/SectionWrapper';
import {
  groupFieldHasContent,
  transformProperties,
} from 'remote-com-shared/domains/prismic/helpers';
import { whenProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { DescriptionComponent, TitleComponent } from '../sharedStyles';

import { fieldHasContent } from '@/src/domains/prismic/helpers';
import { defaultPrismicComponents } from '@/src/domains/prismic/render';

const ContentContainer = styled(ContentContainerBase)`
  display: flex;
  flex-direction: column;
`;

const FeatureSectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ComingSoon = styled.div`
  text-transform: uppercase;
  font-family: var(--typography-fontBossa);
  font-size: 20px;
  color: var(--color-tone-font);
  margin: 72px 0;
`;

export function FeaturesSectionSlice({ slice }) {
  const { primary, fields } = transformProperties(slice);
  const { title, description, comingSoonLabel } = primary;

  return (
    <SectionWrapper>
      <ContentContainer>
        {fieldHasContent(title) && (
          <TitleComponent>
            <PrismicRichText field={title} />
          </TitleComponent>
        )}
        {fieldHasContent(description) && (
          <DescriptionComponent>
            <PrismicRichText field={description} components={defaultPrismicComponents} />
          </DescriptionComponent>
        )}

        {groupFieldHasContent(fields, 'featureTitle') && (
          <FeatureSectionContainer>
            <FeatureSection fields={fields.filter(({ comingSoon }) => !comingSoon)} />
            {/* checks that there are any coming soon remaining */}
            {!!fields.find(({ comingSoon }) => comingSoon) && (
              <ComingSoon>{comingSoonLabel}</ComingSoon>
            )}
            <FeatureSection fields={fields.filter(({ comingSoon }) => comingSoon)} />
          </FeatureSectionContainer>
        )}
      </ContentContainer>
    </SectionWrapper>
  );
}

const FeaturesContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  gap: 48px;
`;

const FeatureContainer = styled.div`
  width: 120px;
  text-align: center;

  ${whenProp(
    '$comingSoon',
    css`
      img {
        opacity: 50%;
      }
    `
  )}
`;

const FeatureTitle = styled.div`
  color: var(--color-tone-font);
  font-family: var(--typography-fontBossa);
`;

function FeatureSection({ fields }) {
  if (!groupFieldHasContent(fields, 'featureTitle')) return null;
  return (
    <FeaturesContainer>
      {fields.map(({ icon, featureTitle, comingSoon }, index) => (
        <FeatureContainer key={index} $comingSoon={comingSoon}>
          {icon && <Image src={icon.url} {...icon.dimensions} alt={icon.alt || ''} />}
          <FeatureTitle>{featureTitle}</FeatureTitle>
        </FeatureContainer>
      ))}
    </FeaturesContainer>
  );
}
